var requiredJSLoaded = false;

namespace Pages._Camera.Player.Test.RequestLatestStill {

    export function onDocumentReady() {

        let controlDiv = $("<div style='display:none'>");

        let prodDiv = $(`<div style='margin-bottom:10px;display:inline-block;'><span style='width:100px;display:inline-block;'>ProductID&nbsp;</span></div>`);
        let prodTxt = $(`<input type='text' class='camera-request-productid' value='301' />`);
        prodDiv.append(prodTxt);
        controlDiv.append(prodDiv);

        let regDiv = $(`<div style='margin-bottom:10px;'><span style='width:100px;display:inline-block;'>Registration&nbsp;</span></div>`);
        let regTxt = $(`<input type='text' class='camera-request-registration' />`);
        regDiv.append(regTxt);
        controlDiv.append(regDiv);

        let groupController: CDN.Camera.GroupController;
        controlDiv.append(prodDiv, regDiv);

        $("body").append(controlDiv);

        let lightDiv = $("<div style='padding: 20px;'>");
        $("body").append(lightDiv);

        let login = new CDN.Controls.Login(document.body, {
            onError: (err) => {
                console.error(err);
            },
            onLogin: (result) => {
                controlDiv.show();
                login.hide();
                regTxt.autocomplete({
                    source: function (request, response) {
                        CDN.API.AutoComplete.v1.searchVehiclesAsync({
                            productId: prodTxt.val(),
                            userToken: result.UserToken,
                        }, regTxt.val()).then(success => {
                            response($.map(success, function (item) {
                                return {
                                    label: item.Registration,
                                    vehicleId: item.VehicleId,
                                    registration: item.Registration,
                                    fleetNum: item.Fleetnum,
                                    product: "",
                                    productid: prodTxt.val(),
                                    usertoken: result.UserToken,
                                    departId: item.DepartId,
                                    depotId: item.DepotId,
                                };
                            }));
                        }, err => {
                        });
                    },
                    minLength: 3,
                    open: function () { $(this).removeClass("ui-corner-all").addClass("ui-corner-top"); },
                    select: function (event, ui) {
                        let registration = ui.item.value;
                        let vehicleId = ui.item.vehicleId;
                        let fleetNum = ui.item.fleetNum;

                        lightDiv.empty();
                        groupController?.destroy();

                        let controllerDiv = $("<div>");
                        lightDiv.append(controllerDiv);
                        groupController = new CDN.Camera.GroupController(controllerDiv.get(0), {
                            groupName: "Test Players",
                        });

                        CDN.API.Camera.Player.v1.getActiveVehicleCamerasAsync({
                            productId: prodTxt.val(),
                            userToken: result.UserToken,
                        }, vehicleId).then(cameras => {
                            for (let camera of cameras) {
                                let fetchBtn = $(`<button>Fetch</button>`);
                                lightDiv.append("<br/><br/>", fetchBtn, "<br/>");
                                let camDiv = $("<div style='display:inline-block'>");
                                let lightCameraPlayer = new CDN.Camera.Player(camDiv, {
                                    productId: prodTxt.val(),
                                    userToken: result.UserToken,
                                }, camera,
                                    {
                                        timeZone: 0,
                                        showControls: false,
                                        showPlayBackBar: false,
                                        groupController: groupController,
                                    });

                                lightDiv.append(camDiv);

                                fetchBtn.click((e) => {
                                    CDN.API.Camera.Player.v1.getRequestsByPriorityAsync(
                                        lightCameraPlayer.user, {
                                        cameraId: lightCameraPlayer.cameraDetails.ID,
                                        types: [CDN.API.Camera.SharedEnums.RequestType.LatestImage],
                                        dateTimeStart: null,
                                        dateTimeEnd: null,
                                        statuses: [0],
                                        limit: 1
                                    }).then((requests) => {
                                        let start = new Date();
                                        start.setMilliseconds(0);

                                        if (requests.length == 0) {
                                            CDN.API.Camera.Player.v1.createRequestAsync(
                                                lightCameraPlayer.user,
                                                {
                                                    cameraId: lightCameraPlayer.cameraDetails.ID,
                                                    start: start,
                                                    end: start,
                                                    type: CDN.API.Camera.SharedEnums.RequestType.LatestImage
                                                })
                                                .then((request) => {
                                                    lightCameraPlayer.fetchFramesAsync({
                                                        requestId: request.id,
                                                    });
                                                });
                                        }
                                        else {
                                            lightCameraPlayer.fetchFramesAsync({
                                                requestId: requests[0].id,
                                            });
                                        }
                                    });
                                });
                            }

                            /*lightDiv.append("<div style='height:1200px;width:100%;background-color:#EEEEEE;display:block;'></div>");*/
                        });
                    },
                    close: function () { $(this).removeClass("ui-corner-top").addClass("ui-corner-all"); }
                });
            },
        });
    }
}

CDN.requireOnce([
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.JQuery_UI, },
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.API_AutoComplete_v1, },
    { code: CDN.PackageCode.Control_Login, },
    { code: CDN.PackageCode.Control_UI_TimePicker, },
    { code: CDN.PackageCode.Camera_Player, },
], () => {
    requiredJSLoaded = true;
    $(document).ready(Pages._Camera.Player.Test.RequestLatestStill.onDocumentReady);
});